import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
// import Card from '@gerenciatd/next.components.card-n';
import styles from '../styles';
const MainBreakDownPageFake = () => {
  const parentDiv = document.getElementsByClassName('container')[0] || window;
  const contentWidth = parentDiv.clientWidth || window.innerWidth;

  if (contentWidth < 767) {
    return (
      <div className="BreakDownFormFake">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12">
              {/* <Card> */}
                <ContentLoader
                  height="395"
                  width={contentWidth}
                  {...fakeSettings}
                >
                  <rect
                    x={contentWidth * 0.05}
                    y="10"
                    rx="1"
                    ry="1"
                    width={contentWidth * 0.9}
                    height="32.5"
                  />
                  <rect
                    x={contentWidth * 0.125}
                    y="62"
                    rx="1"
                    ry="1"
                    width={contentWidth * 0.75}
                    height="32.5"
                  />
                  <rect
                    x={contentWidth * 0.125}
                    y="112"
                    rx="1"
                    ry="1"
                    width={contentWidth * 0.75}
                    height="32.5"
                  />
                  <rect
                    x={contentWidth * 0.125}
                    y="162"
                    rx="1"
                    ry="1"
                    width={contentWidth * 0.75}
                    height="130"
                  />
                  <rect
                    x={contentWidth * 0.25}
                    y="302"
                    rx="1"
                    ry="1"
                    width={contentWidth * 0.5}
                    height="32.5"
                  />
                </ContentLoader>
              {/* </Card> */}
            </div>
          </div>
        </div>
        <style jsx>{styles}</style>
      </div>
    );
  }
  return (
    <div className="BreakDownFormFake">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12">
            <Card>
              <ContentLoader
                height="340"
                width={contentWidth}
                {...fakeSettings}
              >
                <rect
                  x={(contentWidth - (0.8 * contentWidth)) / 2}
                  y="10"
                  rx="1"
                  ry="1"
                  width={0.8 * contentWidth}
                  height="32"
                />
                <rect
                  x={contentWidth * 0.05}
                  y="80"
                  width={0.4 * contentWidth}
                  height="30"
                />
                <rect
                  x={contentWidth * 0.55}
                  y="80"
                  width={0.4 * contentWidth}
                  height="30"
                />
                <rect
                  x={contentWidth * 0.05}
                  y="140"
                  height="120"
                  width={0.9 * contentWidth}
                />
                <rect x={(contentWidth / 2) - 90} y="275" rx="1" ry="1" width="180" height="32" />
              </ContentLoader>
            </Card>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}


export default MainBreakDownPageFake;
